export default __webpack_public_path__ + "static/media/enjoyCard1.2ab4ea80.webp";